import request from '@/utils/request';
import Resource from '@/api/resource';

class IntegrationResource extends Resource {
  constructor() {
    super('admin/integrations');
  }

  // Get all FTP requests (pending, approved, rejected)
  getFtpRequests(query) {
    return request({
      url: '/admin/ftp-requests',
      method: 'get',
      params: query,
    });
  }

  // Approve FTP request
  approveFtpRequest(id) {
    return request({
      url: '/admin/ftp-requests/' + id + '/approve',
      method: 'post',
    });
  }

  // Reject FTP request
  rejectFtpRequest(id, reason) {
    return request({
      url: '/admin/ftp-requests/' + id + '/reject',
      method: 'delete',
      data: { reason },
    });
  }

  // Get all active integrations
  getIntegrations(query) {
    return request({
      url: '/admin/integrations',
      method: 'get',
      params: query,
    });
  }

  // Toggle integration status
  toggleIntegration(id) {
    return request({
      url: '/admin/integrations/' + id,
      method: 'put',
      data: { status: 'toggle' },
    });
  }

  // Create FTP account for user
  createFtpAccount(id, data) {
    return request({
      url: '/admin/integrations/' + id + '/create-ftp',
      method: 'post',
      data: data,
    });
  }

  // Get all custom integration requests
  getCustomIntegrationRequests(query) {
    return request({
      url: '/admin/integration-requests',
      method: 'get',
      params: query,
    });
  }

  // Search users for FTP creation (AJAX)
  searchUsers(query) {
    return request({
      url: '/admin/integrations/search-users',
      method: 'get',
      params: { q: query },
    });
  }

  // Create manual FTP account
  createManualFtpAccount(data) {
    return request({
      url: '/admin/integrations/manual',
      method: 'post',
      data: data,
    });
  }

  // Generate random password
  generatePassword() {
    return request({
      url: '/admin/integrations/generate-password',
      method: 'get',
    });
  }

  // Get import logs (paginated, filterable)
  getImportLogs(query) {
    return request({
      url: '/admin/import-logs',
      method: 'get',
      params: query,
    });
  }

  // Get import statistics (last 24h)
  getImportStats() {
    return request({
      url: '/admin/import-logs/stats',
      method: 'get',
    });
  }

  // Get FTP connection status for all integrations
  getFtpStatus() {
    return request({
      url: '/admin/ftp-status',
      method: 'get',
    });
  }

  // Trigger FTP check for a single integration
  checkFtpNow(integrationId) {
    return request({
      url: '/admin/integrations/' + integrationId + '/check-ftp',
      method: 'post',
    });
  }
}

export { IntegrationResource as default };
